<template>
    <div class="inner">
      <inner-top :tabIndex="2"></inner-top>
      <!-- 考勤明细 -->
      <div>
        <div class="inner_con">
          <div class="inner_search">
            <a-form
              layout="inline"
              :labelCol="{ lg: { span: 5 } }"
              :wrapperCol="{ lg: { span: 18 } }"
              labelAlign="left"
            >
              <div class="ulrow_list" style="width:100%">
                <a-form-item label="考勤时间" class="w100">
                  <div>
                    <a-date-picker
                      @change="changeDate"
                      format="YYYY-MM-DD"
                      :disabled-date="disabledEndDate"
                      v-model="attendStartDate"
                    />
                    <span class="date-text">到</span>
                    <a-date-picker
                      @change="changeDate"
                      format="YYYY-MM-DD"
                      :disabled-date="disabledDate"
                      v-model="attendEndDate"
                    />
                  </div>
                </a-form-item>
                <div
                  class="date-tips pl78"
                  :class="{ 'date-err': attendDays > 185 }"
                >
                  单次查询日期的最长跨度为6个月
                </div>
              </div>
              <!-- 高级选项 -->
              <div class="option" v-show="isTab2Advanced">
                <div class="ulrow pl78">
                  <div class="ulrow_list">
                    <a-form-item label="考勤老师" class="w100">
                      <a-select
                        allowClear
                        show-search
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        v-model="xhrParams.teacherName"
                        @dropdownVisibleChange="
                          dropdownVisibleChange($event, 'teacherNameList')
                        "
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option
                          v-for="(item, index) in teacherNameList"
                          :value="item"
                          :key="index"
                          >{{ item }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="手机号" class="w100">
                      <a-input
                        class="form-cell"
                        type="number"
                        placeholder="请输入"
                        v-model="xhrParams.mobile"
                      ></a-input>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="课程名称" class="w100">
                      <a-select
                        allowClear
                        show-search
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        v-model="xhrParams.courseName"
                        @dropdownVisibleChange="
                          dropdownVisibleChange($event, 'courseNameList')
                        "
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option
                          v-for="(item, index) in courseNameList"
                          :value="item"
                          :key="index"
                          >{{ item }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="课程类型" class="w100">
                      <a-select
                        allowClear
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        v-model="xhrParams.courseType"
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option value="1">特色课</a-select-option>
                        <a-select-option value="2">社团课</a-select-option>
                        <a-select-option value="3">托管班</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="班级名称" class="w100">
                      <a-select
                        allowClear
                        show-search
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        v-model="xhrParams.className"
                        @dropdownVisibleChange="
                          dropdownVisibleChange($event, 'classNameList')
                        "
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option
                          v-for="(item, index) in classNameList"
                          :value="item"
                          :key="index"
                          >{{ item }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="课节名称" class="w100">
                      <a-select
                        allowClear
                        show-search
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        v-model="xhrParams.lessonName"
                        @dropdownVisibleChange="
                          dropdownVisibleChange($event, 'lessonNameList')
                        "
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option
                          v-for="(item, index) in lessonNameList"
                          :value="item"
                          :key="index"
                          >{{ item }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="课程提供方" class="w100">
                      <a-select
                        allowClear
                        show-search
                        placeholder="请选择"
                        :not-found-content="fetching ? undefined : null"
                        @change="serviceChange"
                        v-model="xhrParams.serviceProvider"
                        @dropdownVisibleChange="
                          dropdownVisibleChange($event, 'serviceProviderList')
                        "
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                        />
                        <a-select-option
                          v-for="(item, index) in serviceProviderList"
                          :value="item.name"
                          :key="index"
                          >{{ item.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
  
                  <div class="ulrow_list">
                    <a-form-item label="考勤状态" class="w100">
                      <a-select
                        allowClear
                        placeholder="请选择"
                        v-model="xhrParams.checkinStatus"
                      >
                        <a-select-option value="1">正常</a-select-option>
                        <a-select-option value="-1">异常</a-select-option>
                        <a-select-option value="2">请假</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>

                  <div class="ulrow_list">
                    <a-form-item label="老师类型" class="w100">
                      <a-select
                      allowClear
                      placeholder="请选择"
                      v-model="xhrParams.teacherType"
                    >
                      <a-select-option value="1">主讲老师</a-select-option>
                      <a-select-option value="2">助教老师</a-select-option>
                      <a-select-option value="3">运营人员</a-select-option>
                      <a-select-option value="4">值班老师</a-select-option>
                      <a-select-option value="6">自主考勤</a-select-option>
                    </a-select>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <div class="search-oper pl78 w100">
                <a-button type="primary" @click="queryNewList">查询</a-button>
                <!-- <a-button type="primary" @click="clearSelect">重置</a-button> -->
                <a class="advanced-option" @click="tab2Advanced">
                  <span v-show="!isTab2Advanced">查看</span>
                  <span v-show="isTab2Advanced">隐藏</span>高级选项</a
                >
                <a
                  class="download flex-items"
                  :class="downLoading ? 'disabled' : ''"
                  @click="!downLoading ? exportOrder() : ''"
                >
                  <img v-if="!downLoading" src="/order/exportOrder_icon.png" />
                  {{ downLoading ? '导出中...' : 'Excel导出' }}
                </a>
              </div>
            </a-form>
          </div>
  
          <div>
            <div class="inner_con_tit">
              <span :class="show ? '' : 'active'">
                <a-checkbox :checked="checkAll" @change="onCheckAllChange">
                </a-checkbox>
              </span>
              <span v-if="show">考勤日期</span>
              <span v-if="show">考勤时间</span>
              <span v-if="show">考勤老师</span>
              <span v-if="show">类别</span>
              <span v-if="show">性别</span>
              <span v-if="show">手机号</span>
              <span v-if="show">老师来源</span>
              <span v-if="show">来源名称</span>
              <span v-if="show">课程名称</span>
              <span v-if="show">课程类型</span>
              <span v-if="show">班级名称</span>
              <span v-if="show">课节名称</span>
              <span v-if="show">课程提供方</span>
              <span v-if="show">上课日期</span>
              <span v-if="show">上课时间</span>
              <span v-if="show">考勤状态</span>
              <span v-if="show">备注</span>
              <a
                v-if="!show"
                @click="deletedAttendanceDetail"
                class="green green2"
                >删除</a
              >
              <a v-if="!show" @click="quxiao" class="green green2">取消选择</a>
            </div>
            <a-checkbox-group
              v-model="checkedList"
              style=" width:100%"
              @change="onallChange"
            >
              <a-spin :spinning="spinning">
                <div
                  class="inner_list"
                  v-for="(item,index) in tableData"
                  :key="index"
                  :class="item.active ? 'checkedListactive' : ''"
                >
                  <div class="inner_con_tit1">
                    <span>
                      <a-checkbox
                        :value="item.checkinId"
                        :options="plainOptions"
                      ></a-checkbox>
                    </span>
                    <span>{{ item.attendDate | date('YYYY-MM-DD') }}</span>
                    <span>{{ item.checkinTime }}</span>
                    <span>{{ item.teacherName }}</span>
                    <span>{{ item.teacherType }}</span>
                    <span>{{ item.gender }}</span>
                    <span>{{ item.mobile }}</span>
                    <span>{{ item.teacherOffering }}</span>
                    <span>{{ item.teacherOfferingName }}</span>
                    <span>{{ item.courseName }}</span>
                    <span>{{ item.courseTypeText }}</span>
                    <span>{{ item.className }}</span>
                    <span>{{ item.lessonName }}</span>
                    <span>{{ item.serviceProvider }}</span>
                    <span>{{ item.attendDate | date('YYYY-MM-DD') }}</span>
                    <span>{{ item.classTime }}</span>
                    <span v-if="item.checkinStatus != -1">{{
                      item.checkinStatusText
                    }}</span>
                    <span v-else>
                      <a-button
                        type="danger"
                        style="width:60px;height:30px"
                        @click="abnormal(item)"
                        v-if="item.listImgUrl"
                        >异常</a-button
                      >
                      <div type="danger" style="color:red" v-else>
                        异常
                      </div>
                    </span>
                    <span slot="content" slot-scope="text">{{
                      text ? text : '无'
                    }}</span>
                    <span :title="item.content"><div class="ellipsis">{{ item.content }}</div></span>
                  </div>
                </div>
                <a-empty v-if="tableData.length == 0" :image="simpleImage" />
              </a-spin>
            </a-checkbox-group>
            
            <div class="fenye">
              <a-pagination
                v-model="pagination.current"
                :total="pagination.total"
                :showSizeChanger="true"
                :pageSize="pagination.pageSize"
                :pageSizeOptions="pagination.pageSizeOptions"
                :showTotal="(total) => `总共 ${total} 条`"
                @change="fenye(pagination.current, pagination.pageSize)"
                @showSizeChange="showSizeChange"
              />
            </div>
          </div>
  
          <!-- 异常图片 -->
          <a-modal
            title="异常签到"
            :visible="showImg"
            :confirm-loading="confirmLoading"
            :width="492"
            :footer="null"
            @cancel="imgCancel"
          >
            <div class="abnormal-img">
              <div v-for="(item, index) in imgUrlList" :key="index">
                <img :src="item" alt="" />
              </div>
              <div class="no-img" v-if="imgUrlList.length == 0">无备注图片</div>
            </div>
          </a-modal>
        </div>
      </div>
      <a-spin
        class="fix-spin"
        :spinning="downLoading"
        tip="下载中，请勿操作..."
      />
    </div>
  </template>
  
  <script>
  import moment from 'moment'
  import {
    getSelectList,
    getClassHourStatistic,
    getCollectList,
    deletedAttendanceDetail,
  } from '../../api/report'
  import CSchoolSelect from '../../components/CSchoolSelect'
  import innerTop from './components/innerTop.vue'
  import { downloadExcelFile } from '../../utils'
  import { Empty } from 'ant-design-vue'
  import Vue from 'vue'
import dayjs from 'dayjs'
  
  export default {
    name: 'workDetail',
    data() {
      return {
        // 考勤明细分页
        pagination: {
          current: 1,
          pageSize: 100,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        }, //分页数据对象
        fetching: false,
        statusClassName: ['', 'success', 'warning', 'disabled', ''],
        checkStatusText: ['待签到', '正常', '请假', '未签到', '其他'],
        isTab2Advanced: false, // 考勤明细高级选项
        schoolList: [],
        // time: [],
        attendStartDate: '', // 考勤明细开始时间
        attendEndDate: '', // 考勤明细结束时间
        attendDays: '', // 考勤明细相差月数
        xhrParams: {
          currentPage: 1,
          pageSize: 100,
          startAttendDate: '',
          endAttendDate: '',
          teacherName: undefined,
          mobile: undefined,
          courseName: undefined,
          courseType: undefined,
          className: undefined,
          lessonName: undefined,
          schoolName: undefined,
          checkinStatus: undefined,
          serviceProvider: undefined,
          sourceType: undefined,
          teacherOffering: undefined,
          teacherOfferingName: undefined,
          schoolId: undefined,
        }, // 考勤明细
        tableLoading: true,
        downLoading: false,
        tableData: [], // 考勤明细
        classNameList: [], // 班级名称
        courseNameList: [], // 课程名称
        lessonNameList: [], // 课节名称
        schoolNameList: [], // 学校名称
        serviceProviderList: [], // 服务学校
        teacherOfferingNameList: [], // 来源名称
        teacherNameList: [], // 老师名称
        imgUrlList: [], // 异常图片
        showImg: false, // 异常图片是否显示
        confirmLoading: false,
        checkAll: false,
        checkedList: [],
        show: true,
        title: '',
        plainOptions: [],
        indeterminate: true,
        simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
        spinning: false,
      }
    },
    components: {
      CSchoolSelect,
      innerTop,
    },
    methods: {
      deletedAttendanceDetail() {
        deletedAttendanceDetail({ ids: this.checkedList }).then((res) => {
          this.getListData(this.xhrParams)
          this.quxiao()
        })
      },
      onallChange(checkedList) {
        if (checkedList == undefined || checkedList.length == 0) {
          this.show = true
        } else {
          this.show = false
        }
        this.checkedList = checkedList
        this.checkAll = checkedList.length === this.plainOptions.length
      },
      quxiao() {
        this.show = true
        this.checkAll = false
        this.checkedList = []
      },
      fenye(page, pageSize) {
        this.quxiao()
        this.xhrParams.currentPage = page
        this.getListData(this.xhrParams)
      },
      onCheckAllChange(e) {
        if (this.checkedList.length !== this.plainOptions.length) {
          this.checkedList = this.plainOptions.map((item) => item.checkinId)
          this.checkAll = true
          this.show = false
        } else {
          this.quxiao()
        }
      },
      showSizeChange(current, pageSize) {
        this.xhrParams.currentPage = current
        this.pagination.pageSize = pageSize
        this.xhrParams.pageSize = pageSize
        if(this.tableData.length > 0){
          this.getListData(this.xhrParams)
        }
      },
      exportOrder() {
        let _this = this
        this.$confirm({
          title: '注意',
          okText: '确定',
          cancelText: '取消',
          icon:'exclamation-circle',
          content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
          onOk() {
            if (_this.attendStartDate == '' || _this.attendEndDate == '') {
              _this.$message.error('请选择日期')
          return
        }
        _this.downLoading = true
      downloadExcelFile(
        '/api/pcWeb/report/exportAttendanceDetails',
        '考勤明细.xlsx',
        _this.xhrParams
      ).then(() => {
        _this.downLoading = false
      })
        },
      })
      },
      // 选择日期
      changeDate(event) {
        if (this.attendStartDate == null) {
          this.attendStartDate = ''
          this.xhrParams.startAttendDate = ''
          return
        } else if (this.attendEndDate == null) {
          this.attendEndDate = ''
          this.xhrParams.endAttendDate = ''
          return
        }
        this.attendDays = Math.abs(
          moment(this.attendEndDate).diff(moment(this.attendStartDate), 'days')
        )
        this.xhrParams.startAttendDate = moment(this.attendStartDate).format(
          'YYYY-MM-DD'
        )
        this.xhrParams.endAttendDate = moment(this.attendEndDate).format(
          'YYYY-MM-DD'
        )
      },
      // 控制选择日期范围
      disabledDate(current) {
        return current && current < moment(this.attendStartDate)
      },
      // 控制选择日期范围
      disabledEndDate(current) {
        return current && current > moment(this.attendEndDate)
      },
  
      // 考勤明细高级选项
      tab2Advanced() {
        if (!this.isTab2Advanced) {
          this.isTab2Advanced = true
        } else {
          this.isTab2Advanced = false
        }
      },
      // 课程提供方下拉
      serviceChange(value) {
        if(value == undefined){
          delete this.xhrParams.serviceProvider
          delete this.xhrParams.sourceType
        }
        this.serviceProviderList.forEach((v) => {
          if (value === v.name) {
            this.xhrParams.serviceProvider = v.name
            this.xhrParams.sourceType = v.type
          }
        })
  
      },
      // 切换分页
      onChange(page) {
        this.xhrParams.currentPage = page.current
        this.getListData(this.xhrParams)
      },
      chooseListValue(index, list, key) {
        this.xhrParams[key] = this[list][index]
      },
      searchHandle(value, list) {
        return this.classNameList.filter((item) => item.includes(value))
      },
      // 搜索下拉框
      dropdownVisibleChange(type, list) {
        if (type && !this[list].length) {
          this.fetching = true
          setTimeout(() => {
            const key = list.charAt(0).toUpperCase() + list.slice(1)
            this[list] = [...this[`cache${key}`]]
            this.fetching = false
          }, 200)
        }
      },
      // 查询考勤明细
      queryNewList() {
        this.quxiao()
        if (this.attendDays > 185) {
          this.$message.error('单次查询日期的最长跨度为6个月')
          return
        } else if (this.attendStartDate == '' || this.attendEndDate == '') {
          this.$message.error('请输入日期')
          return
        } 
        this.xhrParams.schoolId = Vue.ls.get('schoolId')
        this.xhrParams.currentPage = 1
        this.pagination.current = 1
        this.getListData({ ...this.xhrParams })
      },
      // 切换考勤明细分页
      changePage(page) {
        this.pagination.current = page
      },
      // 考勤明细
      async getListData(params) {
        this.spinning = true
        const data = await getClassHourStatistic(params).finally(() => {
          this.spinning = false
        })
        this.tableData = data.data.records
        this.plainOptions = this.tableData
        this.pagination.total = data.data.total
      },
  
      // 下拉框数据
      async getSelectList(numbers) {
        const res = await getSelectList(numbers)
        this.classNameList = res.data.className
        this.courseNameList = res.data.courseName
        this.lessonNameList = res.data.lessonName
        this.schoolNameList = res.data.schoolName
        this.serviceProviderList = res.data.serviceProvider
        this.teacherOfferingNameList = res.data.teacherOfferingName
        this.teacherNameList = res.data.teacherName
      },
  
      // 异常按钮
      abnormal(item) {
        this.showImg = true
        if (item.listImgUrl) {
          this.imgUrlList = item.listImgUrl
        } else {
          this.imgUrlList = []
        }
      },
  
      // 关闭异常弹框
      imgCancel() {
        this.showImg = false
      },
      getRowKey(record, index) {
      return index;
    },
    },
    activated() {
      if (this.$route.params.go) {
        this.isTab2Advanced = true
        this.xhrParams = this.$route.params.xhrParams
        if (this.xhrParams.teacherOffering == 1) {
          this.teacherOfferingChoose = '学校'
        } else if (this.xhrParams.teacherOffering == 2) {
          this.teacherOfferingChoose = '课程提供方'
        }
        this.attendStartDate = this.$route.params.attendStartDate
        this.attendEndDate = this.$route.params.attendEndDate
        this.getListData(this.xhrParams)
        this.xhrParams.teacherId = ''
        this.pagination.pageSize = this.xhrParams.pageSize
        this.queryNewList()
      } else {
        if (!this.attendStartDate && !this.attendEndDate) {
          this.attendStartDate = moment(dayjs().subtract(1, 'month').format('YYYY-MM-DD'))
          this.xhrParams.startAttendDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
          this.attendEndDate = moment(dayjs())
          this.xhrParams.endAttendDate = dayjs().format('YYYY-MM-DD')
        }
      }
      this.changeDate()
      let numbers = Vue.ls.get('schoolId')
      this.getSelectList(numbers) // 获取下拉框数据
    },
  }
  </script>
  
  <style lang="less" scoped>
  .w100 {
    width: 100%;
  }
  .pl78 {
    padding-left: 78px;
  }
  .mb15 {
    margin-bottom: 15px;
  }
  /deep/ .ant-form-item-label-left {
    width: 78px;
  }
  
  .inner {
    width: calc(100% - 40px);
    margin: 20px auto;
    background: white;
    border-radius: 8px;
  }
  .inner_top {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    line-height: 40px;
    margin-bottom: 20px;
    div {
      font-size: 14px;
      color: #909399;
      display: inline-block;
      width: 90px;
      text-align: center;
      border-bottom: 2px solid white;
    }
    .item-active {
      color: #37C894;
      border-bottom: 2px solid #37C894;
    }
  }
  .inner_title {
    color: rgba(16, 16, 16, 100);
    font-size: 20px;
    padding-bottom: 20px;
  }
  .inner_con {
    background: #fff;
    padding: 20px;
  }
  // 选择日期提示文字
  .date-tips {
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    margin-top: 8px;
  }
  // 选择日期超出范围
  .date-err {
    color: #ff0000;
  }
  // 选择日期之间文字
  .date-text {
    margin: 0 16px;
  }
  .ulrow {
    display: flex;
    flex-wrap: wrap;
  }
  .ulrow_list {
    width: calc(100% / 4);
    margin-bottom: 15px;
  }
  .ulrow_list_tuwo {
    width: 50%;
    text-align: right;
  }
  .inner_con h2 {
    font-size: 16px;
    font-weight: bold;
  }
  
  .search-oper {
    width: 100%;
    display: flex;
    align-items: center;
    .advanced-option {
      margin-left: 42px;
    }
  }
  .download {
    display: inline-block;
    // margin-left: 20px;
    margin-left: auto;
    text-decoration: none;
    color: #1890ff;
    position: relative;
    font-size: 14px;
  }
  .spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
  }
  .fix-spin {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 50vh;
    color: #68CC2E;
  }
  ::v-deep .ant-spin-dot-item {
    background-color: #68CC2E;
  }
  
  /deep/ .ant-modal-title {
    text-align: center;
    color: rgba(16, 16, 16, 100);
    font-size: 28px;
  }
  
  // 手机号输入
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
  
  // 异常图片
  .abnormal-img {
    div {
      margin-bottom: 33px;
    }
    .no-img {
      font-size: 18px;
      color: rgba(16, 16, 16, 100);
      text-align: center;
      margin-bottom: 0;
    }
    img {
      display: block;
      width: 321px;
      height: 205px;
      margin: 0 auto;
    }
  }
  .inner_con_tit {
    margin-top: 20px;
    background: #fafafa;
    border-bottom: #e8e8e8 1px solid;
    display: flex;
    span {
      line-height: 54px;
      font-size: 14px;
      font-weight: 500;
      color: #151517;
    }
  }
  .inner_con_tit1 {
    margin-top: 20px;
    border-bottom: #e8e8e8 1px solid;
    display: flex;
    span {
      line-height: 54px;
      font-size: 14px;
      font-weight: 500;
      color: #151517;
    }
  }
  .inner_con_tit span:nth-child(1) {
    width: 2%;
    display: flex;
    margin-left: 14px;
  }
  .inner_con_tit span:nth-child(2) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(3) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(4) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(5) {
    padding: 0 3px;
    width: 4%;
  }
  .inner_con_tit span:nth-child(6) {
    padding: 0 3px;
    width: 4%;
  }
  .inner_con_tit span:nth-child(7) {
    padding: 0 3px;
    width: 7%;
  }
  .inner_con_tit span:nth-child(8) {
    padding: 0 3px;
    width: 5%;
  }
  .inner_con_tit span:nth-child(9) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(10) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(11) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(12) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(13) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(14) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(15) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(16) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(17) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span:nth-child(18) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit span.active {
    width: auto;
  }
  .inner_con_tit1 span:nth-child(1) {
    width: 2%;
    display: flex;
    margin-left: 14px;
  }
  .inner_con_tit1 span:nth-child(2) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(3) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(4) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(5) {
    padding: 0 3px;
    width: 4%;
  }
  .inner_con_tit1 span:nth-child(6) {
    padding: 0 3px;
    width: 4%;
  }
  .inner_con_tit1 span:nth-child(7) {
    word-wrap: break-word;
    word-break: normal;
    padding: 0 3px;
    width: 7%;
  }
  .inner_con_tit1 span:nth-child(8) {
    padding: 0 3px;
    width: 5%;
  }
  .inner_con_tit1 span:nth-child(9) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(10) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(11) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(12) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(13) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(14) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(15) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(16) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(17) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span:nth-child(18) {
    padding: 0 3px;
    width: 6%;
  }
  .inner_con_tit1 span.active {
    width: auto;
  }
  .inner_list_con span::after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 10px;
    background: #cfd2db;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -3px;
  }
  .fenye {
    padding: 15px 0;
    text-align: right;
  }
  .inner_con_tit span.active {
    width: auto;
  }
  .inner_list {
    margin-top: 16px;
  }
  .green {
    color: #1890ff;
    font-size: 14px;
    margin-left: 20px;
  }
  .green2 {
    display: flex;
    align-items: center;
  }
  .spin-content {
    border: 1px solid #91d5ff;
    background: rgba(0, 0, 0, 0.05);
    padding: 30px;
  }
  .inner_con_tit1 span {
    line-height: 28px !important;
    margin-bottom: 10px;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
  }
</style>
  